<template>
    <div >
        <el-row>
            <el-col :span="24" style="text-align: left;"><el-button type="primary" size="small" round @click="openDialog(null)" >添加</el-button></el-col>
        </el-row>

        <table style="width: 80%;">
            <tr v-for="item in newsData" :key="item.id" @click="rowClick(item)">
                
                <td class="col-md-6-1 content_padding">
                    {{item.name}}
                </td>
                <td class="col-md-2 content_padding">
                    <div class="overlay border-0">
                        <img class="card-img" :src="item.url" alt="Card image" style="max-height: 9rem;">
                      </div>
                </td>
                <td class="col-md-1-1 content_padding">
                    <el-button type="primary" size="mini" icon="el-icon-edit" circle @click="openDialog(item)"></el-button>
                    <el-button type="danger" size="mini" icon="el-icon-delete" circle @click="deleteNews(item.id)"></el-button>
                </td>
             
            </tr>
          </table>
         
        
        <el-dialog
          title="提示"
          :visible.sync="dialogVisible"
          width="30%">
          <el-form :model="currentRow">
            
            <el-form-item label="名称" :label-width="formLabelWidth">
                <el-input placeholder="请输入名称" v-model="currentRow.name" style="display: inline;margin-left: 5px; " 
                clearable required>
                </el-input>
            </el-form-item>
            
            <el-form-item label="图片" :label-width="formLabelWidth">
              <el-upload
                class="avatar-uploader"
                :before-upload="beforeUpload"
                action="" 
                :show-file-list="false"
                :on-change="handleFileChange"
              :file-list="fileList"  
                >
                <img v-if="isImage" :src="currentRow.url" class="avatar"  />
                
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
              <el-button type="primary" @click="saveInfo">确 定</el-button>
            <el-button @click="dialogVisible = false">取 消</el-button>
          </div>
        </el-dialog>
            
    </div>
</template>
<script>
    
  import {submitDataInfo,getDataInfo} from "@/api/rbac/about";
  
export default{
    components: {
    //   VueEditor
    },
    data(){
        return{
            dialogVisible:false,
    
            newsData:[],    
            currentRow:{id:0,name:'',url:''},
            formLabelWidth: '120px',
            fileList:[],
            isImage: false,
            isVideo: false,
            editorOptions: {
                
            },
            isdetail:false,
            detailInfo:"",
        }
    },
    created() {
            this.loadDataList();
          },
    methods:{
        async loadDataList() {
            try {
                getDataInfo({strType:'AboutUs'}).then(res=>{
                    if (res.data.length==0) {
                        // console.log(this.dataList)
                    }
                    else{
                        this.newsData=res.data;
                        this.newsData.forEach(comNew => {
                            comNew.url="../../../assets/img/About/"+comNew.url;
                        });
                    }
                })
            } catch (error) {
            console.error('获取失败:', error);
            }
        },
        rowClick(item){
            this.currentRow = { ...item }
        },

        openDialog(item) {
            this.dialogVisible = true
            
            // 深拷贝避免直接修改原数据
            if (item) {
                this.currentRow = { ...item }
                const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'webp'];
                const videoExtensions = ['mp4', 'webm', 'ogg', 'avi', 'mkv',''];
                const extension = this.currentRow.url.split('.').pop().toLowerCase();
                if (imageExtensions.includes(extension)) {
                    this.isImage=true;
                    this.isVideo=false;
                }
                if (videoExtensions.includes(extension)) {
                    this.isImage=false;
                    this.isVideo=true;
                }
            } else {
            this.currentRow = { id:0,name:'',url:''};
            }
        },
        beforeUpload(file) {
            const isImage = file.type.startsWith('image/');
            const isVideo = file.type.startsWith('video/');
            if (isImage) {
                this.isImage = true;
                this.isVideo = false;
            } else if (isVideo) {
                this.isVideo = true;
                this.isImage = false;
            }
            return false; // 阻止自动上传
        },
        handleFileChange(file, fileList) {
            //this.fileList = fileList;
            console.log('fileList',fileList)
            this.fileList=[];
            this.fileList.push(file)
            if (file.status === 'ready') {
                // 当文件状态为 ready 时，生成预览 URL
                const reader = new FileReader();
                reader.onload = (e) => {
                this.currentRow.url = e.target.result;
                };
                reader.readAsDataURL(file.raw);
            }
        },
        saveInfo()
        {
            if (!String(this.currentRow.title).trim()) {
                return alert("请填写名称")
            }
            
            if (this.fileList.length==0&&this.currentRow.id==0) {
                return alert("请选择图片")
            }
            const formData = new FormData();
            this.fileList.forEach((file) => {
            formData.append('files[]', file.raw);
            });
            formData.append("strType","AboutUs")
            formData.append("ID",this.currentRow.id)
            formData.append("name",this.currentRow.name)
            try {
                submitDataInfo(formData).then(res=>{
                    if (res.length==0) {
                        alert('失败');
                    }
                    else{
                        alert('成功');
                        this.dialogVisible=false;
                        this.currentRow={id:0,name:'',url:''};
                        this.loadDataList();
                    }
                })
            } catch (error) {
                alert('未成功');
            }
        },
        showDetail(content){
            this.detailInfo=content;
            this.isdetail=true;
        },
        detailClose(){
            this.detailInfo="";
            this.isdetail=false;
        },
    }
}
</script>
<style scoped>
    .avatar-uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 178px;
  height: 178px;
}
.avatar-uploader:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>